import "../utils/staleChunkReload"

import "../utils/flashToasts"

require("../src/application/setup")
require("../src/application/toggle-controls")

import "../utils/safeCssInsertRulePatch"

import "../stylesheets/home-search.css.sass"
import "../pages/HomePageV2Landing/landingMotion.css"

import ReactOnRails from "react-on-rails"

import MobileMenu from "../components/header/MobileMenu"
import HomePageV2 from "../pages/HomePageV2/HomePageV2"
// eslint-disable-next-line no-unused-vars
import dayJsPlugins from "../utils/dayJsPlugins"

const components = {
  HomePageV2,
  MobileMenu
}

ReactOnRails.register(components)

document.addEventListener("DOMContentLoaded", function () {
  document.dispatchEvent(new Event("turbolinks:load", { bubbles: true, cancelable: true }))
})
